const pics = [
  'https://images.dog.ceo/breeds/affenpinscher/n02110627_8949.jpg',
  'https://images.dog.ceo/breeds/dingo/n02115641_5492.jpg',
  'https://images.dog.ceo/breeds/poodle-toy/n02113624_1844.jpg',
  'https://images.dog.ceo/breeds/pointer-german/n02100236_619.jpg',
];

export const getPic = () => pics[Math.floor(Math.random() * pics.length)];
